module.exports = __webpack_public_path__ + "socgen_logo_full.6e7aa7ab.svg";